export enum LlmModel {
  mixtral87b = 'groq/mixtral-8x7b-32768',
  llama2 = 'groq/llama2-70b-4096',
  gpt35 = 'openai/gpt-3.5-turbo-0125',
  gpt4 = 'openai/gpt-4o',
  gpt4Vision = 'openai/gpt-4-vision-preview',
  mistralTiny = 'mistral/mistral-tiny',
  mistralSmall = 'mistral/mistral-small',
  mistralMedium = 'mistral/mistral-medium',
  geminiPro = 'gemini/gemini-pro',
  geminiProVision = 'gemini/gemini-pro-vision',
  anthropicClaudeInstant1 = 'bedrock/anthropic.claude-instant-v1',
  anthropicClaude2 = 'bedrock/anthropic.claude-v2:1',
}

export enum OpenaiModel {
  gpt35 = 'gpt-4o-mini',
  gpt4 = 'gpt-4o',
  gpt4Vision = 'gpt-4-vision-preview',
  o1 = 'o1-preview',
  o1Mini = 'o1-mini',
}

export enum GroqModel {
  llama3 = 'llama3-70b-8192',
  mixtral = 'mixtral-8x7b-32768',
}

export const codeInterpreterTool = {
  type: 'code_interpreter',
};

export const retrievalTool = {
  type: 'retrieval',
};

export interface FunctionTool {
  type: 'function';
  function: OpenaiFunction;
}

export interface OpenaiThreadMessage {
  id: string;
  object: 'thread.message';
  created_at: number;
  thread_id: string;
  role: string;
  content: OpenaiThreadMessageContent[];
}

export interface OpenaiThreadMessageContent {
  type: 'text' | 'image_file';
  text: {
    value: string;
    annotations: {
      type: 'file_citation' | 'file_path';
      text: string;
      file_path?: {
        file_id: string;
      };
      file_citation?: {
        file_id: string;
        quote: string;
      };
      start_index: number;
      end_index: number;
    }[];
  };
}

export interface OpenaiThread {
  id: string;
  object: 'thread';
  created_at: number;
  metadata?: any;
}

export interface OpenaiAssistant {
  id: string;
  model: LlmModel;
  name?: string;
  description?: string;
  instructions?: string;
  tools?: { type: string }[];
  // Max 20 files
  file_ids?: [];
  metadata?: any;
}

export interface OpenaiMessage {
  role: 'system' | 'user' | 'assistant';
  content: string | any;
  file_ids?: string[];
  metadata?: any;
}

export interface OpenaiRun {
  id: string;
  object: 'thread.run';
  created_at: number;
  thread_id: string;
  assistant_id: string;
  status: OpenaiRunStatus;
  required_action?: {
    type: string;
    submit_tool_outputs: {
      tool_calls: {
        id: string;
        type: string;
        function: { name: string; arguments: string };
      }[];
    };
  };
  last_error?: any;
  expires_at: number;
  started_at?: number;
  cancelled_at?: number;
  failed_at?: number;
  completed_at?: number;
  model: LlmModel;
  instructions: string;
  tools: OpenaiTool[];
  file_ids: string[];
  metadata: any;
}

export interface OpenaiTool {
  type: string;
  function?: OpenaiFunction;
}

export enum OpenaiRunStatus {
  queued = 'queued',
  in_progress = 'in_progress',
  requires_action = 'requires_action',
  cancelling = 'cancelling',
  cancelled = 'cancelled',
  failed = 'failed',
  completed = 'completed',
  expired = 'expired',
}

export interface OpenaiFunction {
  name: string;
  description: string;
  parameters: {
    type: string;
    properties: {
      [key: string]: {
        type: string;
        description?: string;
        enum?: string[];
        items?: {
          type: string;
          properties?: {
            [key: string]: {
              type: string;
              description?: string;
              enum?: string[];
              items?: any;
            };
          };
        };
      };
    };
  };
}
